<template>
  <div id="page-wrap">
    <div class="container-fluid">
      <div class="container">
        <div class="content-wrap">
          <div class="header">
            <h1>睿客网FAQ文档</h1>
          </div>
          <div class="content">
            <h2>一、睿客网是什么？</h2>
            <ul>
              <p>
                睿客网（REC），即中国科学技术大学科研教学资源中心，为科大师生用户提供数据存储、备份、分享等服务的在线平台。
              </p>
            </ul>
            <h2>二、睿客网能做什么？</h2>
            <ul>
              <p>
                睿客网目前提供了“云盘”和“群组”两大服务。云盘，提供了文件存储、分享、在线预览和编辑服务，使您无论在PC端，还是移动端都可以方便的将本地文件上传、备份到云端。群组，为用户提供群内上传和分享文件，创建和参与话题讨论，也可以邀请或申请加入您感兴趣的其他群组，参与群组活动。
              </p>
            </ul>
            <h2>三、睿客网将来是什么？</h2>
            <ul>
              <p>
                睿客网未来将基于存储、资源和群组，推出更多线上应用，更好地服务科研、教学与管理。
              </p>
            </ul>
            <h2>四、如何使用云盘？</h2>
            <ul>
              <p>
                睿客网，仅向科大师生用户开放，可使用校内统一身份认证帐号快速登录平台。您可以选择使用PC端、手机APP或者WEB端，在“云盘”中，上传、创建、下载文件，创建目录，管理自己的文件。还可以将文件便捷地分享给他人。目前支持的分享类型为：链接分享（包含免密分享和私密分享）、用户分享、群组分享。
              </p>
            </ul>
            <h2>五、如何创建群组？</h2>
            <ul>
              <p>
                如果您是科大师生，请使用校内统一身份认证帐号登录WEB端。在“群组”模块点击“创建群组”，也可以在“用户中心”的“群组”管理模块下，创建群组。创建的群组需要在管理员审核通过后才能使用。
              </p>
            </ul>
            <h2>六、加入群组</h2>
            <ul>
              <p>
                如果您是科大师生，请使用校内统一身份认证帐号登录WEB端。在“群组”模块下，选择感兴趣的群组，并进入到该群主页，申请加入群组；也可以联系群管理员，邀请您加入群组。
              </p>
            </ul>
            <h2>七、空间容量不够了怎么办？</h2>
            <ul>
              <p>
                睿客网用户默认开设1TB云盘存储空间。您在使用过程中，如果需要更多空间容量，可以在WEB端“云盘”模块右上角点击“申请扩容”，填写申请理由和申请增加的空间容量（请按实际需要申请），提交。管理员将及时进行处理。审核通过后即可扩容成功。审核结果将以站内信方式发送到“用户中心”的消息中。
              </p>
            </ul>
            <h2>八、发现不良信息如何举报?</h2>
            <ul>
              <p>
                睿客网是一个面向科大师生用户提供数据存储、备份、分享等服务的在线平台。用户对上传及在睿客网平台公开传播的内容承担主体责任。平台仅作为教学科研使用，请勿放置违法内容。如果您在睿客网平台的分享、群组资源、话题板块下，发现任何违法不健康内容，均可提出举报，举报内容将会提交给管理员，核实后，管理员有权对被举报内容进行锁定及删除处理。
              </p>
            </ul>
            <h2>九、有意见如何反馈？</h2>
            <ul>
              <p>
                欢迎对平台功能、性能、服务等使用方面提出您的宝贵建议，您可以在睿客网WEB端页面右上角“意见反馈”模块下提交意见，管理员在收到反馈意见后将会及时处理。
              </p>
            </ul>
            <h2>十、如何安装PC客户端？</h2>
            <ul>
              <p>
                您可以在 http://rec.ustc.edu.cn/download
                页面选择所需的客户端版本进行安装；目前提供安装版和免安装版两种方式，用户可以根据需要选择。
              </p>
            </ul>
            <h2>十一、睿客网PC客户端支持什么操作系统和版本？</h2>
            <ul>
              <p>目前支持 win7 / win8 / win10</p>
            </ul>
            <h2>十二、如何安装手机APP？</h2>
            <ul>
              <p>
                您可以在 http://rec.ustc.edu.cn/download
                页面选择所需的客户端版本进行安装。
              </p>
            </ul>
            <h2>十三、如何访问老版的课程网页？</h2>
            <ul>
              <p>
                新版睿客网已经正式上线，域名统一切换为 rec.ustc.edu.cn
                ，原睿客网的数据已同步至新版睿客网，原课程功能调整中。课程模块可以通过页面右上角的“访问旧版课程”链接访问。如有疑问、建议或者意见，请联系管理员。
              </p>
            </ul>
            <h2>十四、如何访问睿客网微信版？</h2>
            <ul>
              <p>
                睿客网微信版目前正在调试中，待上线后您可以在科大企业号找到“睿客云盘”应用，点击进入使用。
              </p>
            </ul>
            <h2>十五、离校后是否可以继续使用睿客网？</h2>
            <ul>
              <p>
                睿客网需要通过校内统一身份认证帐号登录使用，您在离校后，若需要继续使用睿客网，可以联系管理员处理。
              </p>
            </ul>
            <h2>十六、被举报的资源是否可以解除锁定状态？</h2>
            <ul>
              <p>
                资源若被举报一定次数，会被系统自动锁定。若您的资源被恶意举报，请联系管理员，申请解锁。
              </p>
            </ul>
            <h2>十七、备份文件是否长期有效？</h2>
            <ul>
              <p>备份文件长期有效。</p>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  created() {
    this.$store.commit("SET_THEME", "FAQ文档");
  },
};
</script>

<style scoped>
</style>